<template>
  <div>
    <a-card style="margin-bottom: 10px">
      <div class="filter-section">
      <!--  <input type="datetime-local"
               v-model="test"/>-->
        <a-form layout="inline" ref="form" :model="form">
          <a-form-item label="状态" name="state">
            <a-select
              style="width: 140px"
              v-model:value="form.state"
              @change="handleChange"
            >
              <a-select-option key="">
                全部
              </a-select-option>
              <a-select-option v-for="item in labelState" :key="item.state" :state="item.state">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="名称" name="name">
            <!--<a-input style="width: 200px" placeholder="请输入名称"
              v-model:value="form.name">
              <template v-slot:suffix><search-outlined type="user"/></template>
            </a-input>-->
            <a-input style="width: 200px" placeholder="请输入名称" v-model:value="form.name" autocomplete="off">
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData(1)">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <div class="table-title">
        <p class="table-name">发布任务列表</p>
        <a-button
          type="primary"
          @click="openDialog('add')"
        >
          创建任务
        </a-button>
      </div>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:taskType="{ text }">
          {{ getTaskName(text) }}
        </template>
        <template v-slot:userId="{ text }">
          {{ getUserName(text) }}
        </template>
        <template v-slot:stateName="{ record }">
          {{ record.locking == 'success' ? '任务处理中' : getStateName(record.state) }}
        </template>
        <template v-slot:team="{ text }">
          {{ getTeamName(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:finishTime="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span class="gap-btn">
            <a @click="openDetail(record)">详情</a>
          </span>
          <!--<span class="gap-btn">
            <a @click="showDeleteConfirm(record)">删除</a>
          </span>-->
          <span class="gap-btn">
            <a :class="(record.locking != 'success' && (record.state == 'origin' || record.state == 'merge'))?'':'grey'" @click="(record.locking != 'success' && (record.state == 'origin' || record.state == 'merge'))?showDeleteConfirm(record):''">删除</a>
          </span>
          <span class="gap-btn">
            <a :class="(record.locking != 'success' && record.state == 'already_deny')?'':'grey'" @click="(record.locking != 'success' && record.state == 'already_deny')?openDialog('edit', record):''">重新分配</a>
          </span>
          <!--<span class="gap-btn" v-if="record.state == 'under_check'">
            <a @click="handleAccept(record)">验收</a>
          </span>-->
          <!--<span class="gap-btn">
            <a :class="record.state == 'under_check'?'':'grey'" @click="record.state == 'under_check'?handleAccept(record):''">验收</a>
          </span>-->
          <span class="gap-btn">
            <a :class="(record.locking != 'success' && record.state == 'already_annotation')?'':'grey'" @click="(record.locking != 'success' && record.state == 'already_annotation')?handleMerge(record):''">合并</a>
          </span>
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <create-task ref="createTask"
      :currentItem="currentItem"
      :dialogType="dialogType"
      :taskTypes="taskTypes"
       @refreshData="getData"></create-task>
    <task-detail ref="taskDetail" :current-item="currentItem"></task-detail>
    <AcceptDialog ref="acceptDialog" :current-item="currentItem"></AcceptDialog>
  </div>
</template>
<script>
// import { SearchOutlined } from '@ant-design/icons-vue'
import TaskDetail from './TaskDetail'
import AcceptDialog from './AcceptDialog'
import { getMyRelease, deleteTask, updateTask } from '@/api/task'
import { getDateTime, getTeamName, getTaskName, getStateName, getUserName } from '@/filters'
import { mapState } from 'vuex'
import CreateTask from './CreateTask.vue'
const columns = [
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '任务类型',
    dataIndex: 'taskTypeId',
    slots: { customRender: 'taskType' }
  },
  {
    title: '状态',
    // dataIndex: 'state',
    slots: { customRender: 'stateName' }
  },
  {
    title: '发布人',
    dataIndex: 'createUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '团队',
    dataIndex: 'teamId',
    slots: { customRender: 'team' }
  },
  {
    title: '发布时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '要求完成时间',
    dataIndex: 'planFinishTime',
    slots: { customRender: 'finishTime' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    // SearchOutlined,
    TaskDetail,
    AcceptDialog,
    CreateTask
  },
  data () {
    return {
      test: '',
      labelState: [{ name: '待接收', state: 'origin' },
        { name: '待拆分', state: 'already_accept' },
        { name: '已拒绝', state: 'already_deny' },
        { name: '待分配', state: 'waiting_assign' },
        { name: '待标注', state: 'waiting_annotate' },
        { name: '标注中', state: 'doing_annotation' },
        { name: '已标注', state: 'already_annotation' },
        { name: '已合并', state: '合并' }],
      form: {
        state: '',
        name: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dialogType: '',
      currentItem: {},
      taskTypes: []
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted () {
    this.taskTypes = JSON.parse(localStorage.getItem('taskTypes'))
    this.getData(1)
  },
  methods: {
    getDateTime,
    getTeamName,
    getTaskName,
    getStateName,
    getUserName,
    resetForm () {
      // console.log('999', this.test)
      this.$refs.form.resetFields()
    },
    handleChange (value, item) {
      // console.log('999', item)
      this.form.state = item.state
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      const params = Object.fromEntries(Object.entries(this.form).filter(arr => arr[1]))
      getMyRelease({ ...this.form, ...this.page, ...params, parentId: 'nullValue', field: 'createTime', order: 'desc' }).then(res => {
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
      })
    },
    // 数据处理
    dataProcess (raw) {
      return raw.map(i => ({ ...i, ...i.labourAssignRecord }))
    },
    // 单个删除确认
    showDeleteConfirm (item) {
      this.$confirm({
        title: '删除任务',
        content: '仅可删除“未分配”和“已完成”的任务，确认删除？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          this.handleDelete([item.id])
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    // 删除
    async handleDelete (ids) {
      this.loading = true
      for (const id of ids) {
        await deleteTask(id).then(res => {
          this.$message.success('任务已删除')
          this.loading = false
          this.getData(1)
        }).catch(e => e)
      }
    },
    handleMerge (item) {
      this.$confirm({
        title: '合并标注数据',
        content: '将标注结果合并进原数据？此操作将覆盖原数据',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          updateTask({
            id: item.id,
            state: 'merge'
          }).then(res => {
            this.$message.success('数据已合并')
            this.getData(1)
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    openDetail (item) {
      this.currentItem = item
      this.$refs.taskDetail.open()
    },
    // 创建任务/重新分配
    openDialog (type, item) {
      this.dialogType = type
      this.currentItem = type === 'edit' ? { ...item } : {}
      this.$refs.createTask.open()
    },
    handleAccept (item) {
      this.currentItem = item
      this.$refs.acceptDialog.open()
    }
  }
}
</script>
<style>

</style>
